import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { theme } from '../styles/theme';

// Card cliccabile con titolo, sottotitolo opzionale, badge opzionale e freccia
// icon: icona FontAwesome opzionale a sinistra del testo. badgeVariant: 'brand' (rosa, default) | 'muted' (grigio)
// meta: testo secondario opzionale sotto il badge (es. "24 iscritti")
function MenuCard({ title, subtitle, badge, badgeVariant = 'brand', icon, meta, onClick }) {
  return (
    <div style={styles.card} onClick={onClick}>
      {icon && (
        <div style={styles.iconBox}>
          <FontAwesomeIcon icon={icon} style={styles.icon} />
        </div>
      )}
      <div style={styles.textContainer}>
        <h3 style={styles.title}>{title}</h3>
        {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      </div>
      <div style={styles.right}>
        {(badge !== undefined || meta) && (
          <div style={styles.badgeColumn}>
            {badge !== undefined && (
              <span style={badgeVariant === 'muted' ? styles.badgeMuted : styles.badge}>{badge}</span>
            )}
            {meta && <span style={styles.meta}>{meta}</span>}
          </div>
        )}
        <FontAwesomeIcon icon={faChevronRight} style={styles.arrow} />
      </div>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius,
    boxShadow: theme.shadows.main,
    margin: '8px 0',
    padding: '16px 20px',
    cursor: 'pointer',
    width: '100%',
    maxWidth: '500px',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconBox: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: theme.colors.background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '14px',
    flexShrink: 0,
  },
  icon: {
    fontSize: '18px',
    color: theme.colors.brand,
  },
  textContainer: {
    textAlign: 'left',
    minWidth: 0,
    flex: 1,
  },
  title: {
    fontSize: '18px',
    color: theme.colors.text,
    margin: '0 0 4px 0',
    textAlign: 'left',
  },
  subtitle: {
    fontSize: '14px',
    color: theme.colors.textSecondary,
    margin: 0,
    textAlign: 'left',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0,
  },
  badge: {
    backgroundColor: theme.colors.brand,
    color: theme.colors.white,
    borderRadius: '12px',
    padding: '2px 10px',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  badgeColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
  },
  meta: {
    fontSize: '12px',
    color: theme.colors.textSecondary,
    whiteSpace: 'nowrap',
  },
  badgeMuted: {
    backgroundColor: theme.colors.background,
    color: theme.colors.textSecondary,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '12px',
    padding: '2px 10px',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  arrow: {
    fontSize: '16px',
    color: theme.colors.brand,
  },
};

export default MenuCard;
